import { useStyleSheet } from '../../../../../../hooks/useStyleSheet';
import { SelectOptionProps } from '../../SelectOption.types';
import { SelectContainerProps } from './SelectContainer.types';

export const useStyles = ({
  errorMessage,
  label,
  isFocused,
}: Pick<SelectOptionProps, 'errorMessage' | 'label'> & Pick<SelectContainerProps, 'isFocused'>) => {
  const styles = useStyleSheet(
    (theme) => ({
      root: {
        fontSize: theme.fontSizes.h5,
        color: theme.palette.text.primary,
        position: 'relative',
        zIndex: isFocused ? 10001 : 10000,
      },
      labelContainer: {
        marginBottom: theme.spacing.tertiary,
        label: {
          color: theme.palette.text.primary,
        },
      },
      errorMessageContainer: {
        marginTop: theme.spacing.tertiary,
        label: {
          color: theme.palette.error.main,
        },
      },
    }),
    [errorMessage, label, isFocused],
  );

  return styles;
};
